import { Palette, SvgIconProps, useTheme } from '@mui/material'
import React from 'react'

import { iconsMap, IconType } from '#/components/Icon/map'

const SIZE = {
  large: 24,
  medium: 20,
  small: 16,
}

export type IconProps = {
  name?: IconType
  size?: keyof typeof SIZE | number
  disabled?: boolean
  color?: NonNullable<SvgIconProps['style']>['color'] | keyof Palette
} & Omit<SvgIconProps, 'fontSize' | 'color'>

export const Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color, disabled, name, size = 'medium', style, ...rest }, ref) => {
    const { palette } = useTheme()

    if (!name) {
      return null
    }

    const resolvedSize = typeof size === 'number' ? size : SIZE[size]
    const resolvedColor = color && color in palette ? palette[color]?.main : color

    const icon = iconsMap[name]

    if (!icon) {
      console.info('%c[Icon] Ícone não mapeado: %c' + name, 'color: orange;', 'color: red;')
      return null
    }

    return React.cloneElement(icon, {
      ref,
      size: resolvedSize,
      ...rest,
      style: {
        color: disabled ? undefined : resolvedColor,
        fontSize: resolvedSize,
        ...style,
      },
    })
  },
)
